import { render, staticRenderFns } from "./FreightOrders.vue?vue&type=template&id=44bea920"
import script from "./FreightOrders.vue?vue&type=script&lang=js"
export * from "./FreightOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Freight/FreightOrders.vue
// module id = 2303
// module chunks = 31